import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router';

import { reviewSchoolYears } from 'ducks';
import { duckify, filterDuck } from 'utils/duckify';
import Placeholder from 'components/Placeholder';
import withSchoolYear from 'hocs/withSchoolYear';
import Routes from '../../../routes';
import CandidatesInReviewContactList from './CandidatesInReviewContactList';

const CandidatesInReview = ({
  schoolYears,
  schoolYearId,
  allDucksReady
}) => (
  <Placeholder.loading
    ready={allDucksReady}
    content={() => {
      let reviewYear;

      if (schoolYearId) {
        reviewYear = schoolYears.find(year => year.id === schoolYearId);
      }

      if (!reviewYear && schoolYears.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        reviewYear = schoolYears[0];
      }

      return (
        <React.Fragment>
          {reviewYear ? (
            <CandidatesInReviewContactList reviewYear={reviewYear} />
          ) : (
            <div className='review-contact-list__card'>
              <div className='review-contact-list__card-body'>
                <span>Review has not been setup for any school year. Visit&nbsp;</span>
                <a href={Routes.review_path()}>Review Settings</a>
                <span>&nbsp;to setup a review year.</span>
              </div>
            </div>
          )}
        </React.Fragment>
      );
    }}
  />
);

CandidatesInReview.propTypes = {
  /** SchoolYearId prop */
  schoolYearId: PropTypes.string,

  /** SchoolYears Duck */
  schoolYears: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      review_enabled: PropTypes.bool
    })
  ),

  /** allDucksReady prop */
  allDucksReady: PropTypes.bool
};

CandidatesInReview.defaultProps = {
  schoolYearId: null,
  schoolYears: [],
  allDucksReady: false
};

const mapDucksToProps = () => ({
  schoolYears: filterDuck(reviewSchoolYears, { review_enabled: true })
});

export default compose(
  withSchoolYear(() => ''),
  withRouter,
  duckify(mapDucksToProps)
)(CandidatesInReview);
